// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent as firebaseLogEvent } from 'firebase/analytics';
const firebaseConfig = {

  apiKey: "AIzaSyAgVOefwthj1IqstmG8TEwBdeKgmKJMAQQ",

  authDomain: "mybridge-438909.firebaseapp.com",
 databaseURL: "https://mybridge-438909.firebaseio.com",
  projectId: "mybridge-438909",

  // databaseURL: "https://mybridge-438909.firebaseio.com",

  storageBucket: "mybridge-438909.appspot.com",

  messagingSenderId: "163819327253",

  appId: "1:163819327253:web:7b07074703c6f71721231c",

  measurementId: "G-5CFS5T93DK"

};

// Initialize Firebase
export let firebaseApp = null;
export let analyticsInstance = null;
export const getFirebaseApp = () => {
  if (!firebaseApp) {
    firebaseApp = initializeApp(firebaseConfig);
  }
  return firebaseApp;
};
export const getAnalyticsInstance = () => {
  if (typeof window !== 'undefined' && !analyticsInstance) {
    const app = getFirebaseApp();
    analyticsInstance = getAnalytics(app);
  }
  return analyticsInstance;
};

export const logEvent = (eventName, params = {}) => {
  const analytics = getAnalyticsInstance();
  if (analytics) {
    firebaseLogEvent(analytics, eventName, params);
  }
};
export default firebaseApp;
